module.exports = __webpack_public_path__ + "static/img/10.280af2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/10.jpg
// module id = 6mUP
// module chunks = 1